'use client';

import React from 'react';
import { AuthenticationStep } from 'components/AuthenticationStep/AuthenticationStep';
import BrandPageShell from '@/components/BrandPageShell/BrandPageShell';

const LoginPage = () => {
  return (
    <BrandPageShell
      title="Sign in to your Razee account"
      subtitle="Continue your reset journey with the same calm, guided experience you see on Razee Web."
      contentMaxWidth={520}
    >
      <AuthenticationStep />
    </BrandPageShell>
  );
};

export default LoginPage;
